import { tableColumnsWidth, key, slot } from '@/assets/js/resetTableStyle'

export const columns = [
  {
    type: 'selection',
    width: 60,
    align: 'center'
  },
  key('学校名称', 'name', tableColumnsWidth.type7),
  key('所属地区', 'areaName', tableColumnsWidth.type4),
  slot('课程分类', 'courseType', tableColumnsWidth.type7),
  slot('课程分类推送设置', 'action', tableColumnsWidth.default, {
    fixed: 'right'
  })
]
export const courseList = [
  {
    id: 1,
    name: '艺术'
  },
  {
    id: 2,
    name: '科技'
  },
  {
    id: 4,
    name: '体育'
  },
  {
    id: 8,
    name: '美术'
  },
  {
    id: 16,
    name: '综合实践'
  },
  {
    id: 32,
    name: '早托'
  },
  {
    id: 64,
    name: '午托'
  },
  {
    id: 128,
    name: '晚托'
  },
  {
    id: 256,
    name: '晚修'
  }
]
// 课程中心--课程商品
export const courseTypeData = [
  {
    value: -1,
    label: '全部'
  },
  {
    value: 1,
    label: '素质课程',
    children: [
      {
        value: 11,
        label: '艺术'
      },
      {
        value: 12,
        label: '科技'
      },
      {
        value: 13,
        label: '体育'
      },
      {
        value: 14,
        label: '美术'
      },
      {
        value: 15,
        label: '综合实践'
      }
    ],
    loading: false
  },
  {
    value: 2,
    label: '托管',
    children: [
      {
        value: 21,
        label: '早托'
      },
      {
        value: 22,
        label: '午托'
      },
      {
        value: 23,
        label: '晚托'
      },
      {
        value: 24,
        label: '全托'
      }
    ],
    loading: false
  }
]
